/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalGetIterationContextAttributesPathParams = NonNullable<
  operations['internalGetIterationContextAttributes']['parameters']['path']
>;

export interface Input extends InternalGetIterationContextAttributesPathParams {
  apiVersion?: string;
  header: NonNullable<operations['internalGetIterationContextAttributes']['parameters']['header']>;
}

export async function internalGetIterationContextAttributes(
  { apiVersion, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET(
    '/internal/projects/{projectKey}/environments/{environmentKey}/experiments/{experimentKey}/iterations/{iterationId}/context-attributes',
    {
      params: { path, header },
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
